import { Document } from '@kanda-libs/ks-frontend-services';
import { useCallback, useMemo } from 'react';
import { base64toBlob } from 'utils/Base64-functions';

export interface FinalFileCardHook {
  name: string | undefined;
  isLoading: boolean;
  onClick: () => void;
}

export default function useFinalFileCard(file: Document): FinalFileCardHook {
  const name = useMemo(() => file?.name, [file]);

  const onClick = useCallback(() => {
    if (!file) return;
    const { mimetype = 'application/pdf', content } = file;
    if (!content) return;
    const blob = base64toBlob(content, mimetype);
    const w = window.open('about:blank');
    if (!w) return;
    w.location = URL.createObjectURL(blob);
  }, [file]);

  return {
    name,
    isLoading: false,
    onClick,
  };
}
